import React from 'react';
import {
    FiMessageSquare,
  } from "react-icons/fi";
  
function SignupButton(props) {
    return (
        <a
        href="https://put.dev/#start"
        rel="noopener noreferrer"
        target="_blank"
      >
        <button className="btn rounded p-3 w-full cursor-pointer text-center font-bold bg-gray-100 hover:bg-gray-200 border-2 border-indigo-200 hover:border-indigo-600">
          <div className="text-xl text-indigo-700">
            <FiMessageSquare /> New Here?
          </div>
          <div className="text-xs text-indigo-500">
            1 question signup. 20 seconds.
          </div>
        </button>
      </a>
    );
}

export default SignupButton;






